import { ReactNode } from 'react';
import { Fade, Grid, Skeleton } from '@mui/material';

const ViewGridComponent = ({ isLoading, children }: { isLoading: boolean; children: ReactNode[] }) => {
    return (
        <>
            {isLoading ? (
                <Fade in={isLoading}>
                    <Grid container display={'flex'} spacing={2}>
                        <Grid item xs={12} lg={4}>
                            <Skeleton variant="rectangular" height={140} sx={{ borderRadius: '10px' }} />
                            <Skeleton variant="rectangular" height={140} sx={{ borderRadius: '10px', mt: 2 }} />
                            <Skeleton variant="rectangular" height={140} sx={{ borderRadius: '10px', mt: 2 }} />
                        </Grid>
                        <Grid item xs={12} xl={8}>
                            <Skeleton variant="rectangular" height={700} sx={{ borderRadius: '10px', ml: 2 }} />
                        </Grid>
                    </Grid>
                </Fade>
            ) : (
                <Grid
                    container
                    direction="row"
                    xs={12}
                    spacing={{
                        xs: 0,
                        md: 2
                    }}
                    rowSpacing={2}
                >
                    <Grid item xs={12} xl={4}>
                        <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
                            {children[0]}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} xl={8}>
                        {children[1]}
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default ViewGridComponent;
